import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FormFieldModule } from '../form-field/form-field.module';
import { AutocompleteComponent } from './autocomplete.component';
import { SelectOnTabDirective } from './select-on-tab.directive';
import { AutocompleteInputComponent } from './autocomplete-input.component';
import { FocusIfModule } from 'libraries/ui_toolbox/focus-if.module';
import { BlurIfModule } from 'libraries/directive/blur-If/blur-if.module';
import { MatOptionModule } from "@angular/material/core";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FormFieldModule,
        MatAutocompleteModule,
        MatFormFieldModule,
        MatInputModule,
        MatOptionModule,
        FocusIfModule,
        BlurIfModule,
        FontAwesomeModule,
        MatTooltipModule,
    ],
    declarations: [
        AutocompleteComponent,
        AutocompleteInputComponent,
        SelectOnTabDirective,
    ],
    exports: [
        AutocompleteComponent,
        AutocompleteInputComponent,
    ],
    providers: [],
})
export class AutocompleteModule { }
